/* ============================================================
   BioActive+ — Header & Mega Menu interactions (vanilla JS)
   No dependencies. Safe to drop into Shopify Dawn (assets/).
   Re-inits on Dawn's section load events.
   ============================================================ */
(function () {
  function init(root) {
    if (!root || root.__baInit) return;
    root.__baInit = true;

    var stack = root.querySelector('.ba-header-stack');
    var bar = root.querySelector('.ba-bar');

    /* ---- Announcement auto-rotate ---- */
    var msgs = Array.prototype.slice.call(root.querySelectorAll('.ba-ann-msg'));
    var ai = 0;
    function showMsg(i) {
      msgs.forEach(function (m, k) { m.classList.toggle('is-active', k === i); });
    }
    if (msgs.length) {
      showMsg(0);
      if (msgs.length > 1) {
        var annTimer = setInterval(function () { ai = (ai + 1) % msgs.length; showMsg(ai); }, 4200);
        root.querySelectorAll('[data-ann="prev"]').forEach(function (b) {
          b.addEventListener('click', function () { ai = (ai + msgs.length - 1) % msgs.length; showMsg(ai); });
        });
        root.querySelectorAll('[data-ann="next"]').forEach(function (b) {
          b.addEventListener('click', function () { ai = (ai + 1) % msgs.length; showMsg(ai); });
        });
      }
    }

    /* ---- Sticky condense on scroll ---- */
    function onScroll() {
      var c = window.scrollY > 12;
      if (stack) stack.classList.toggle('is-condensed', c);
      if (bar) bar.classList.toggle('is-condensed', c);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ---- Mega menu (desktop hover) ---- */
    var mega = root.querySelector('.ba-mega');
    var scrim = root.querySelector('.ba-scrim');
    var navwrap = root.querySelector('.ba-navwrap');
    var closeTimer = null;

    function openMega(key) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      root.querySelectorAll('.ba-mega-panel').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-mega') === key);
      });
      root.querySelectorAll('.ba-navitem[data-mega]').forEach(function (n) {
        n.classList.toggle('is-open', n.getAttribute('data-mega') === key);
      });
      if (mega) mega.classList.add('is-show');
      if (scrim) scrim.classList.add('is-show');
    }
    function closeMega() {
      if (mega) mega.classList.remove('is-show');
      if (scrim) scrim.classList.remove('is-show');
      root.querySelectorAll('.ba-navitem.is-open').forEach(function (n) { n.classList.remove('is-open'); });
    }
    root.querySelectorAll('.ba-navitem').forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        var k = item.getAttribute('data-mega');
        if (k) openMega(k); else closeMega();
      });
    });
    var wm = root.querySelector('.ba-bar .ba-wordmark');
    var actions = root.querySelector('.ba-actions');
    if (wm) wm.addEventListener('mouseenter', closeMega);
    if (actions) actions.addEventListener('mouseenter', closeMega);
    if (navwrap) navwrap.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeMega, 200); });
    if (mega) mega.addEventListener('mouseenter', function () { if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; } });

    /* ---- Mobile drawer (drill-down) ---- */
    var drawer = root.querySelector('.ba-drawer-root');
    var aside = root.querySelector('.ba-drawer');
    var backLabel = root.querySelector('[data-back-label]');
    var LABELS = { shop: 'Shop', men: 'Men', protocol: 'My Protocol', support: 'Support' };

    function resetView() {
      if (!aside) return;
      aside.classList.remove('is-sub');
      aside.querySelectorAll('.ba-drawer-subpanel').forEach(function (p) { p.classList.remove('is-active'); });
    }
    function openDrawer() { if (drawer) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(resetView, 340); /* return to level 1 once it has slid shut */
    }
    root.querySelectorAll('[data-drawer="open"]').forEach(function (b) { b.addEventListener('click', openDrawer); });
    root.querySelectorAll('[data-drawer="close"]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    var dscrim = root.querySelector('.ba-drawer-scrim');
    if (dscrim) dscrim.addEventListener('click', closeDrawer);

    /* drill in / out */
    function drillTo(key) {
      if (!aside) return;
      aside.querySelectorAll('.ba-drawer-subpanel').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === key);
      });
      if (backLabel) backLabel.textContent = LABELS[key] || '';
      aside.classList.add('is-sub');
      var sub = aside.querySelector('.ba-drawer-sub'); if (sub) sub.scrollTop = 0;
    }
    root.querySelectorAll('[data-open]').forEach(function (b) {
      b.addEventListener('click', function () { drillTo(b.getAttribute('data-open')); });
    });
    root.querySelectorAll('[data-drawer-back]').forEach(function (b) {
      b.addEventListener('click', function () { if (aside) aside.classList.remove('is-sub'); });
    });

    /* collapsible groups within a sub-panel (first group open by default via .is-open in markup) */
    root.querySelectorAll('.ba-grp-head').forEach(function (head) {
      head.addEventListener('click', function () { head.parentElement.classList.toggle('is-open'); });
    });
  }

  function boot() {
    document.querySelectorAll('.bioactive').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Shopify theme editor: re-init when the section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('.bioactive') : null;
    if (el) { el.__baInit = false; init(el); }
  });
})();
